export const SUBSCRIPTION_PATH = {
  SUBSCRIPTION_MANAGEMENT: "/subscriptions",
  CREATE_SUBSCRIPTION_MANAGEMENT: "/subscriptions/new",
  SUBSCRIPTON_DETAILS: "/subscriptions/details/:id",
  SUBSCRIPTION_AUTO_RECONCILED_TRXNS: "/subscriptions/transaction/auto-reconciled",
};
